
(function(){

	var myObj = {
		apis:[]
	};

	myObj.checkForBDC = function(){
        if(typeof window.BDC.Utils.breakpoints != "undefined"){
            this.init();
        }
        else{
        	//restart request animation frame
        	window.requestAnimationFrame(this.checkForBDC);
        }
    };

    //checks if tables are within a text or html block
    myObj.scrollers = function(){
    	//target smaller screens

    	if(window.BDC.Utils.breakpoints.isBP("m-down")){
		    if(this.apis.length == 0){
		    	var $tables = $(".textblock table, .htmlblock table");
	    		$tables.each(function(){
	    			var tableWidth = $(this).width()
	    			var tableRowWidth = $(this).find("tr").width()
	    			if(tableRowWidth > tableWidth){
	    				myObj.apis.push($(this).jScrollPane().data().jsp);
	    			}
	    		});
    		}
    		else{
    			//if smaller screen and apis are set - then reinitialize
    			$.each(
					myObj.apis,
					function(i) {
						this.reinitialise();
					}
				)
    		}
    	}
    	else{
    		//http://jscrollpane.kelvinluck.com/destroy.html
			if (this.apis.length > 0) {
	    		$.each(
					myObj.apis,
					function(i) {
						this.destroy();
					}
				)
				this.apis = [];
    		}
    	}
    	
    };

    //initialize
    myObj.init = function() {
    	$(window).on("resize orientationchange",myObj.scrollers);
    	this.scrollers();

    };

    //bing this to myObj is each function
    myObj.checkForBDC = myObj.checkForBDC.bind(myObj);
    myObj.init = myObj.init.bind(myObj);
    myObj.scrollers = myObj.scrollers.bind(myObj);
    
    //start request animation frame
   	window.requestAnimationFrame(myObj.checkForBDC);
	
})();
